<template>
  <p class="tag" :style="style">
    <strong>
      {{ name || '-' }}
    </strong>
  </p>
</template>

<script>
const colors = {
  1: { background: '#25A02A' },
  2: { background: '#FFE600', color: 'black' },
  3: { background: '#C00000' },
  6: { background: '#7CD581' },
};

const defaultColor = { background: '#EEEEEE', color: '#797979' };

export default {
  name: 'AccountStatus',
  props: {
    id: Number,
    name: String,
  },
  computed: {
    style() {
      return {
        ...(colors[this.id] || defaultColor),
      };
    },
  },
};
</script>

<style scoped>
.tag {
  font-size: 0.85rem;
  width: max-content;
  padding: 0 12px;
  color: white;
  text-align: center;
  border-radius: 3px;
}
</style>